export enum INAPP_UPI_STATE {
    ONBOARDING = "ONBOARDING",
    ADD_ACCOUNT = "ADD_ACCOUNT",
}

export const INAPP_UPI_ERROR_TITLE = "Oops! Something went wrong. Please try again";
export const INAPP_UPI_SUCCESS_TITLE = "Your Swiggy UPI account has been successfully created";

export const INAPP_UPI_HALF_CARD_FREQUENCY = 3;
